<div class="itdr-empty d-flex justify-content-center py-5">
  <div class="itdr-empty__card card shadow-sm text-center py-4 px-5">
    <div class="itdr-empty__icon mb-3">
      <i class="bi bi-shield-lock-fill"></i>
    </div>
    <h5 class="mb-2">Configure the required integrations to get started</h5>
    <p class="text-muted mb-3">
      Identity Security needs to read your directory data before we can do neat things like secure users, score posture,
      and flag identity threats.
    </p>

    <div class="itdr-empty__list mx-auto mb-3">
      @for (label of missingLabels(); track label) {
        <div class="itdr-empty__item">
          <i class="bi bi-arrow-right-short"></i>
          <span>{{ label }}</span>
        </div>
      }
    </div>

    @if (hasSecondaryMissing()) {
      <p class="text-muted small mb-3">
        Start with Microsoft while we work on additional sources that are sure to delight the security minded!
      </p>
    }

    <div>
      <a
        class="btn btn-primary"
        [routerLink]="['/customer/integrations']"
        [queryParams]="{ integration: ctaTarget() }"
        queryParamsHandling="merge"
      >
        {{ ctaLabel() }}
      </a>
    </div>
  </div>
</div>
